import {
  Component,
  computed,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { Activity } from '../../../../../api/activity/activity.model';
import { MatCheckbox } from '@angular/material/checkbox';
import {
  activityRoleLabels,
  roleImportance,
} from '../../../../../api/activity/lib/activity.util';
import { I18nLookupPipe } from '../../../../../util/i18n/i18n-lookup.pipe';

@Component({
  selector: 'app-main-activity-picker',
  standalone: true,
  imports: [MatCheckbox, I18nLookupPipe],
  templateUrl: './main-activity-picker.component.html',
  styleUrl: './main-activity-picker.component.scss',
})
export class MainActivityPickerComponent {
  activities = input.required<Activity[]>();
  mainActivity = signal<Activity | null>(null);
  sideActivities = computed(() =>
    this.activities().filter((a) => a !== this.mainActivity()),
  );
  onMainActivityChanged = output<Activity | null>();

  constructor() {
    effect(
      () => {
        const activities = this.activities();
        const mainActivity = this.mainActivity();
        if (
          mainActivity === null ||
          (mainActivity.id && !activities.find((a) => a.id === mainActivity.id))
        ) {
          this.mainActivity.set(this.getDefaultMainActivity(activities));
        }
      },
      { allowSignalWrites: true },
    );
    effect(() => {
      const mainActivity = this.mainActivity();
      this.onMainActivityChanged.emit(mainActivity);
    });
  }

  getDefaultMainActivity(activities: Activity[]) {
    return activities.sort(
      (a, b) => roleImportance.indexOf(a.role) - roleImportance.indexOf(b.role),
    )[0];
  }

  protected readonly activityRoleLabels = activityRoleLabels;
}
